// import { useTranslation } from 'react-i18next';
import KaKaoAddressSearchLayer from './KaKaoAddressSearchLayer';
import YihaiAddressSearchLayer from './YihaiAddressSearchLayer';
// import ChinaAddressSearchLayer from './ChinaAddressSearchLayer';

function AddressSearchSwitcher({register, setValue, field, fieldState, errors, setAddressInfo, objName, addressInfo}) {
  const timezone      = (process.env.REACT_APP_TIMEZONE || 'Asia/Seoul').toLowerCase();
  // const { i18n } = useTranslation();
  // console.log(addressInfo)

  // 현재 i18next에 설정된 언어에 따라 컴포넌트 분기
  // if (appLanguage === 'zh-cn') {
  if (timezone === ('Asia/Shanghai').toLowerCase()) {
    return <YihaiAddressSearchLayer register={register} field={field} fieldState={fieldState} setAddressInfo={setAddressInfo} objName={objName}
            defaultVal={addressInfo?.address_name || ''} />;
    // if (platformServer === 'YIHAI') {
    //   return <YihaiAddressSearchLayer register={register} field={field} fieldState={fieldState} setAddressInfo={setAddressInfo} objName={objName}
    //         defaultVal={addressInfo?.address_name || ''} />;
    // } else {
    //   return <ChinaAddressSearchLayer field={field} fieldState={fieldState} setAddressInfo={setAddressInfo} objName={objName}
    //         defaultVal={addressInfo?.address_name || ''} defaultLatitude={addressInfo?.lat || ''} defaultLongitude={addressInfo?.lng || ''} />;
    // }
  } else {
    return <KaKaoAddressSearchLayer register={register} setValue={setValue} errors={errors} 
            setAddressInfo={setAddressInfo} objName={objName} defaultVal={addressInfo?.address_name || ''} />;
  }
}

export default AddressSearchSwitcher;
  